// Copyright (c) 2020-2023 Visual Intelligence LP. All rights reserved.
//
export enum DeliverableUnitType {
  feet = 1,
  meters = 2,
}

export const DELIVERABLE_UNIT_TYPE_LABELS = {
  [DeliverableUnitType.feet]: 'Feet',
  [DeliverableUnitType.meters]: 'Meters',
};

export enum DeliverableStatus {
  // Note: do not use 0 which is used as 'undefined' in a number of checks.
  pending = 1,
  inProgress = 2,
  inProgressWithIssues = 3,
  completed = 4,
  failed = 5,
  collectionInProgress = 6,
  collectionDone = 7,
  collectionIncomplete = 8,
  postProcessing = 9,
  postProcessingWithIssues = 10,
  postProcessingFailed = 11,
  postProcessingCompleted = 12,
  completedWithIssues = 13
}

export enum ReadyStatusType {
  none = 0,       
  ready = 1,
  readyPlus = 2 // ready but item is not in pending mode.
}

export const FLAG_READY = 'Ready';
export const DELIVERABLE_STATUS_LABELS = {
  [DeliverableStatus.pending]: 'Pending',
  [DeliverableStatus.inProgress]: 'In progress',
  [DeliverableStatus.inProgressWithIssues]: 'In progress with issues',
  [DeliverableStatus.completed]: 'Complete',
  [DeliverableStatus.failed]: 'Failed',
  [DeliverableStatus.collectionInProgress]: 'Collection in progress',
  [DeliverableStatus.collectionDone]: 'Collection done',
  [DeliverableStatus.collectionIncomplete]: 'Collection incomplete',
  [DeliverableStatus.postProcessing]: 'Post processing',
  [DeliverableStatus.postProcessingWithIssues]: 'Post processing with issues',
  [DeliverableStatus.postProcessingFailed]: 'Post processing failed',
  [DeliverableStatus.postProcessingCompleted]: 'Post processing completed',
  [DeliverableStatus.completedWithIssues]: 'Complete with issues',
};

export const DELIVERABLE_LABEL_2_ID = {
  ['Pending']: 1,
  ['In progress']: 2,
  ['In progress with issues']: 3,
  ['Completed']: 4,
  ['Complete']: 4,
  ['Failed']: 5,
  ['Collection in progress']: 6,
  ['Collection done']: 7,
  ['Collection incomplete']: 8,
  ['Post processing']: 9,
  ['Post processing with issues']: 10,
  ['Post processing failed']: 11,
  ['Post processing completed']: 12,
  ['Complete with issues']: 13
}

export const DELIVERABLE_FIELDS = {
  id: 'id',
  deliverableType: 'deliverableType',
  deliverableTypeName: 'deliverableTypeName',
  deliverableTypeDescription: 'deliverableTypeName',
  projectionId: 'projectionId',
  datumId: 'datumId',
  isInternal: 'isInternal',
  unitType: 'unitType',
  deadline: 'deadline',
  name: 'name',
  status: 'status',
  download: 'download'
  // Many properties are not here.
};

export const DELIVERABLE_EXCEPTION_CODES = {
  none: 'None',
  warning: 'Warning',
  moderate: 'Moderate',
  severe: 'Severe'
}

export const DELIVERABLE_EXCEPTION_CODE_TO_COLOR = {
  '': '#ffffff',
  // For backward compatible.
  'none': '#ffffff',
  'warning': '#ffffc0',
  'moderate': '#fcd299',
  'severe': '#ff7f7f',

  [DELIVERABLE_EXCEPTION_CODES.none]: '#ffffff',
  [DELIVERABLE_EXCEPTION_CODES.warning]: '#ffffc0',
  [DELIVERABLE_EXCEPTION_CODES.moderate]: '#fcd299',
  [DELIVERABLE_EXCEPTION_CODES.severe]: '#ff7f7f'
}